<template>
    <div class="settings">
        <div :class="$prefixClass.row">
            <a-form-model ref="formSettings" :model="formSettings" v-bind="layout">
                <h5 class="m-b-16">{{ $t('loading_screen.settings.loading_effect')}}</h5>
                <a-form-model-item class="d-flex align-items-center m-b-16" :style="formSettings.delay_time ? 'align-items: unset;' : ''">
                    <div slot="label">
                        <span>{{ $t('loading_screen.settings.delay_time')}}</span><br>
                        <span class="text-description fs-sm fw-normal">{{ $t('loading_screen.settings.delay_description')}}</span>
                    </div>
                    <div>
                        <a-select :prefixCls="$prefixClass.select" v-model="formSettings.delay_time">
                            <i class="fas fa-chevron-down" slot="suffixIcon"></i>
                            <a-select-option v-for="(item, index) in listDelayTime" :key="index" :value="item.value">{{item.text}}</a-select-option>
                        </a-select>
                        <a-select class="m-t-8" v-if="formSettings.delay_time" :prefixCls="$prefixClass.select" v-model="formSettings.animation_style">
                            <i class="fas fa-chevron-down" slot="suffixIcon"></i>
                            <a-select-option v-for="(item, index) in listStyle" :key="index" :value="item.value">{{item.text}}</a-select-option>
                        </a-select>
                    </div>
                </a-form-model-item>
                <a-form-model-item class="m-b-32">
                    <div slot="label">
                        <span>Duration time</span><br>
                        <span class="text-description fs-sm fw-normal">{{ $t('loading_screen.settings.duration_description')}}</span>
                    </div>
                    <a-select :prefixCls="$prefixClass.select" v-model="formSettings.duration_time">
                        <i class="fas fa-chevron-down" slot="suffixIcon"></i>
                        <a-select-option v-for="(item, index) in listDuration" :key="index" :value="item.value">{{item.text}}</a-select-option>
                    </a-select>
                </a-form-model-item>
              
                <h5 class="m-b-16">{{ $t('loading_screen.settings.display') }}</h5>
                <a-form-model-item class="m-b-24" :label="$t('loading_screen.settings.when_to_show')">
                    <a-radio-group class="p-l-40" v-model="formSettings.display_show">
                        <a-radio value="first"> {{ $t('loading_screen.settings.first_visit') }}
                        </a-radio>
                        <a-radio value="everytime"> {{ $t('loading_screen.settings.every_visit') }}
                        </a-radio>
                    </a-radio-group>
                </a-form-model-item>
                <a-form-model-item :label="$t('loading_screen.settings.page_to_show')">
                    <div>
                        <a-radio-group v-model="formSettings.page_show_type" class="p-l-40 m-b-8">
                            <a-radio value="every"> {{ $t('loading_screen.settings.every_page') }}
                            </a-radio>
                            <a-radio value="specific"> {{ $t('loading_screen.settings.specific_page') }}
                            </a-radio>
                        </a-radio-group>
                        <VueMultiselectCheckbox v-if="formSettings.page_show_type === 'specific'"
                            :textBtn="title"
                            :data="listPage"
                            :listChecked="formSettings.page_show_specific"
                            :isClearAll="false"
                            :number="2"
                            @onChange="onChangePage"
                        />
                        <!-- <a-dropdown v-if="formSettings.page_show_type === 'specific'" :prefixCls="$prefixClass.dropdown" :trigger="['click']" :overlayClassName="$prefixClass.dropdown + '-default'">
                            <a-menu :prefixCls="$prefixClass.menu" slot="overlay">
                                <a-menu-item v-for="(item, index) in listPage" :key="index">
                                    <a-checkbox v-model="item.checked" @change="onChangePage(item)">
                                        {{item.label}}
                                    </a-checkbox>
                                </a-menu-item>
                            </a-menu>
                            <a-button class="btn-select-page">{{ formSettings.page_show_specific.length > 0 ? formSettings.page_show_specific.length +' Selected' : 'Select page' }}<i class="fas fa-chevron-down m-l-15"></i> </a-button>
                        </a-dropdown> -->
                    </div>
                </a-form-model-item>
            </a-form-model>
        </div>
    </div>
</template>

<script>
export default {
    name: "Settings",
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            title: '',
            listPage: [
                {
                    label: this.$t('loading_screen.pages.home'),
                    value: 'home'
                },
                {
                    label: this.$t('loading_screen.pages.product'),
                    value: 'product'
                },
                {
                    label: this.$t('loading_screen.pages.collection'),
                    value: 'collection'
                },
                {
                    label: this.$t('loading_screen.pages.blog'),
                    value: 'blog'
                },
                {
                    label: this.$t('loading_screen.pages.online_store'),
                    value: 'online-store'
                }
            ],
            listStyle: [
                {
                    text: 'Fade out',
                    value: 'fade-out'
                },
                {
                    text: 'Fade out left',
                    value: 'fade-out-left'
                },
                {
                    text: 'Fade out right',
                    value: 'fade-out-right'
                },
                {
                    text: 'Zoom out',
                    value: 'zoom-out'
                },

            ],
            listDuration: [
                {
                    text: '0s',
                    value: 0
                },
                {
                    text: '1s',
                    value: 1
                },
                {
                    text: '2s',
                    value: 2
                },
                {
                    text: '3s',
                    value: 3
                },
                {
                    text: '4s',
                    value: 4
                }, 
                {
                    text: '5s',
                    value: 5
                }
            ],
            listDelayTime: [
                {
                    text: '0s',
                    value: 0
                },
                {
                    text: '1s',
                    value: 1
                },
                {
                    text: '2s',
                    value: 2
                },
                {
                    text: '3s',
                    value: 3
                },
                {
                    text: '4s',
                    value: 4
                }, 
                {
                    text: '5s',
                    value: 5
                }
            ],
            layout: {
                labelCol: {
                    span: 10
                },
                wrapperCol: {
                    span: 14
                },
            },
        };
    },
    computed: {
        formSettings: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", this.value);
            },
        },
    },
    watch: {
        formSettings: {
            handler() {
                this.$emit('runDemo')
            },
            deep: true
        }
    },
    created() {
        this.title = this.formSettings.page_show_specific && this.formSettings.page_show_specific.length > 0 ? this.formSettings.page_show_specific.length + ' Selected' : 'Select page'
    },
    methods: {
        submitForm() {
        },
        onChangePage(item){
            this.formSettings.page_show_specific = item
            this.title = this.formSettings.page_show_specific && this.formSettings.page_show_specific.length > 0 ? this.formSettings.page_show_specific.length + ' Selected' : 'Select page'
        }
    },
};
</script>

<style lang="scss">
.settings {
    padding: 0 24px 24px 24px;
    .m-dropdown-trigger {
        float: right;
    }
    .m-select {
        float: right;
        width: 140px;
    }
    .a-form-item {
        &-label {
            label {
                margin-bottom: 0;
            }
        }
    }

    .m-multiselect-checkbox {
        width: 130px;
        float: right;
        button {
            width: 100%;
        }
        &-btn-number {
            display: none;
        }
    }

    .a-radio-wrapper {
        &:not(:first-child) {
            margin-top: 8px;
        }
    }
    h3 {
        &:not(:first-child) {
            margin-top: 16px;
        }
        margin-bottom: 16px;
    }
    .text-description {
        display: block;
        max-width: 130px;
    }
}
</style>
